(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kutus-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    const thumb = event.target.closest('[data-gallery-target]');
    if (thumb) {
      const gallery = thumb.closest('[data-kutus-gallery]');
      gallery.querySelectorAll('[data-gallery-index]').forEach(panel => { panel.hidden = panel.dataset.galleryIndex !== thumb.dataset.galleryTarget; });
      gallery.querySelectorAll('[data-gallery-target]').forEach(button => { button.setAttribute('aria-pressed', String(button === thumb)); });
    }
    const zoom = event.target.closest('[data-kutus-zoom]');
    if (!zoom) return;
    const dialog = zoom.closest('[data-kutus-gallery]').querySelector('dialog');
    if (!dialog || !dialog.showModal) return;
    event.preventDefault();
    const full = dialog.querySelector('img');
    full.removeAttribute('srcset');
    full.src = zoom.href;
    full.alt = zoom.querySelector('img').alt;
    dialog.showModal();
    dialog.addEventListener('close', () => { zoom.focus(); }, {once:true});
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kutus-privacy"] && !Shopify.designMode) return;
  try {
    let kutusPrivacyBannerPromise;

  function loadKutusPrivacyBanner() {
    if (typeof window.privacyBanner?.showPreferences === 'function') {
      return Promise.resolve(window.privacyBanner);
    }
    if (kutusPrivacyBannerPromise) return kutusPrivacyBannerPromise;

    kutusPrivacyBannerPromise = new Promise((resolve, reject) => {
      const source = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
      let script = document.querySelector(`script[src="${source}"]`);
      const ownsScript = !script;
      if (!script) {
        script = document.createElement('script');
        script.src = source;
        script.async = true;
      }

      let poll;
      let timeout;
      const cleanup = () => {
        window.clearInterval(poll);
        window.clearTimeout(timeout);
        script.removeEventListener('error', fail);
      };
      const fail = () => {
        cleanup();
        if (ownsScript) script.remove();
        reject(new Error('Shopify privacy banner could not be loaded.'));
      };
      const check = () => {
        if (typeof window.privacyBanner?.showPreferences === 'function') {
          cleanup();
          resolve(window.privacyBanner);
        }
      };

      script.addEventListener('error', fail, { once: true });
      poll = window.setInterval(check, 100);
      timeout = window.setTimeout(fail, 10000);
      if (ownsScript) document.head.appendChild(script);
      check();
    }).catch(error => {
      kutusPrivacyBannerPromise = undefined;
      throw error;
    });

    return kutusPrivacyBannerPromise;
  }

  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-kutus-privacy-open], a[href="#shopifyReshowConsentBanner"]');
    if (!trigger) return;
    event.preventDefault();
    if (trigger.getAttribute('aria-busy') === 'true') return;

    const errorMessage = trigger.closest('.kk-footer')?.querySelector('[data-kutus-privacy-error]');
    if (errorMessage) errorMessage.hidden = true;
    trigger.setAttribute('aria-busy', 'true');
    try {
      const banner = await loadKutusPrivacyBanner();
      await banner.showPreferences();
    } catch (error) {
      if (errorMessage) errorMessage.hidden = false;
      trigger.focus();
    } finally {
      trigger.removeAttribute('aria-busy');
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kutus-purchase"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', event => {
    if (!event.target.matches('[data-kutus-offer] input[name="quantity"]')) return;
    const input = event.target;
    const offer = input.closest('[data-kutus-offer]');
    const pair = input.value === '2';
    offer.querySelector('[data-kutus-single-total]').hidden = pair;
    offer.querySelector('[data-kutus-pair-total]').hidden = !pair;
    const button = offer.querySelector('[data-kutus-primary]');
    if (!button.disabled) button.textContent = input.dataset.label;
    const product = offer.closest('[data-kutus-product]');
    if (product) product.querySelectorAll('[data-kutus-selected-price]').forEach(node => { node.textContent = input.dataset.price; });
  });
  } catch(e) { console.error(e); }
})();

})();
